/** Holds all route names available in the app */
export default class RouteNameConstants {
  public static ROOT = "/";
  public static HOME = "/home";

  public static TOOLS = "/tools";
  public static TOOLS_ONSITE = "/tools/onsite";
  public static TOOLS_OUT_FOR_SERVICE = "/tools/out-for-service";
  public static TOOLS_DETAILS_BASE = "/tool";
  public static TOOLS_DETAILS_CHILD_STATUS = "status";
  public static TOOLS_DETAILS_CHILD_HISTORY = "history";
  public static TOOLS_DETAILS_CHILD_INFO = "info";

  public static TOOL_LOCATION = "/location";

  public static CONTRACTS = "/contracts";
  public static CONTRACTS_DETAILS_BASE = "/contracts";
  public static CONTRACTS_DETAILS_CHILD_INFO = "info";
  public static CONTRACTS_DETAILS_CHILD_TOOLS = "tools";
  public static CONTRACTS_DETAILS_CHILD_ITEMS = "items";
  public static CONTRACTS_DETAILS_CHILD_DOCUMENTS = "documents";

  public static LOGIN = "/login";
  public static REMINDERS = "/reminders";

  public static FIELD_SERVICE = "/field-service";
  public static FIELD_SERVICE_BASE = "/field-service";
  public static FIELD_SERVICE_CHILD_INFO = "info";
  public static FIELD_SERVICE_CHILD_TOOLS = "tools";
  public static FIELD_SERVICE_CHILD_HISTORY = "history";

  public static TECH_COVER = "/tech-cover";
  public static TECH_COVER_CHILD_LIST = "list";
  public static TECH_COVER_CHILD_CREATE_TICKET = "create-ticket";

  public static ADMIN = "/admin";
  public static ADMIN_USERS_NEW = "/admin/users/new";
  public static ADMIN_USERS_PENDING = "/admin/users/pending";
  public static ADMIN_USERS = "/admin/users";
  public static ADMIN_LOCALIZATION = "/admin/localization";
  public static ADMIN_VISIBLE_EVENT = "/admin/visible-event";
  public static ADMIN_DOCUMENT_FILTER = "/admin/document-filter";
  public static ADMIN_REQUESTED_SERVICE_LIST = "/admin/requested-service-list";
  public static ADMIN_APPROVED_SERVICE_PRICE = "/admin/approved-service-price";
  public static ADMIN_CONTACTS = "/admin/contacts";
  public static ADMIN_CUSTOMERS = "/admin/customers";

  public static ADMIN_REMINDER_LIST_BASE = "/admin/reminder-list";
  public static ADMIN_REMINDER_LIST_CHILD_COUNTRY = "country";
  public static ADMIN_REMINDER_LIST_CHILD_COMPANY = "company";

  public static NO_ACCESS = "/no-access";
  public static REQUEST_ACCOUNT = "/request-account";
  public static SERVICE_REQUEST = "/service-request";
  public static PURCHASE_ORDER = "/purchase-order";

  /** Property name of `Data` object in route */
  public static ROUTE_NAME_DATA_PROP = "/routeName";
}
